import Script from 'next/script';
export default function FunctionalScripts({
  nonce,
  consent
}) {
  return <>
			<Script id="tawk-script" nonce={nonce} strategy="lazyOnload" dangerouslySetInnerHTML={{
      __html: `
						var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
						(function(){
						var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
						s1.async=true;
						s1.src='https://embed.tawk.to/5f1a77d9a45e787d128c07c5/default';
						s1.charset='UTF-8';
						s1.setAttribute('crossorigin','*');
						s0.parentNode.insertBefore(s1,s0);
						})();
					`
    }} data-sentry-element="Script" data-sentry-source-file="FunctionalScripts.jsx" />
		</>;
}